const globalPopupStore = {
  namespaced: true,
  state: {
    isShowGlobalPopup: false,
    config: {},
  },
  getters: {
    isShowGlobalPopup: state => state.isShowGlobalPopup,
    config: state => state.config,
  },
  mutations: {
    isShowGlobalPopup(state, flag) {
      state.isShowGlobalPopup = flag;
    },
    setConfig(state, config) {
      state.config = config;
    },
  },
  actions: {
    show({ commit }, config) {
      const isOrderProcessing = user.subscription.status_code === 110;
      const isPlanManuallySetBySaleOnTrial = user.subscription.status_code === 8 && user.subscription.payment_plans_id !== 12;

      if ((config.type === 'upgradePlan' || config.type === 'paymentPopup')) {
        if (isOrderProcessing) {
          webix.message({ type: 'info', text: __('order_processing_message_for_upgrade') });

          return;
        }

        if (isPlanManuallySetBySaleOnTrial) {
          webix.message({ type: 'info', text: __('contact_sale_message_for_upgrate') });

          return;
        }
      }

      commit('isShowGlobalPopup', true);
      commit('setConfig', config);
    },
    async close({ commit }) {
      commit('isShowGlobalPopup', false);
      commit('setConfig', {});
    },
    confirm({ dispatch, state }) {
      if (state.config.confirm) {
        state.config.confirm(state.config.data);
        dispatch('close');

        return;
      }
      dispatch('close');
    },
  },
};

export default globalPopupStore;
